module.exports = __webpack_public_path__ + "static/sponsorship_img3@2x-bc3fb74d0c2d9498e3833f679563abf9.jpg";